import { useContext } from 'react';
import { ManifestContext } from '../context/manifest.context';

export const useManifest = () => {
  const { manifest } = useContext(ManifestContext);

  return manifest;
};
